import React from 'react';
import propTypes from 'prop-types';
import { TriangleAlert } from 'lucide-react';
import { cn } from 'lib/utils';

/**
 * notice for a recommendation list the api answered with `partial: true`: the agency
 * was evaluated fine, but N agents could not be read from Zoho and are missing from
 * the list. this is not the same as a failed request, so it never offers Retry and
 * never hides the cards that did come back — it only warns they are not the whole set.
 * @param partial - whether any agency reported an incomplete list
 * @param skippedAgents - agents left out, summed across agencies
 * @param className - extra classes for the wrapper
 */
export default function PartialRecommendationsNotice({
  partial,
  skippedAgents = 0,
  className
}) {
  if (!partial) return null;

  const count = Number(skippedAgents) || 0;
  const countSuffix = count > 0 ? ` (${count})` : '';

  return (
    <div
      className={cn(
        'flex items-center gap-2 rounded-lg border border-warning-contrast/20',
        'bg-semantic-warning px-3 py-2',
        className
      )}
    >
      <TriangleAlert className='size-4 shrink-0 text-warning-contrast' />
      <p className='m-0 flex-1 text-xs text-warning-contrast'>
        Some agents couldn&rsquo;t be checked right now{countSuffix}. The list
        may be incomplete.
      </p>
    </div>
  );
}

PartialRecommendationsNotice.propTypes = {
  partial: propTypes.bool,
  skippedAgents: propTypes.number,
  className: propTypes.string
};
